import React, {useState, useEffect} from 'react'
import { ButtonPrimary } from "../../../../../Components/Button";
import InvoiceBillingAddressModal from "./InvoiceBillingAddressModal";
import { token } from "../../../../../modules/auth";
import { editVenueFinancials, editVenueFinancialsForEvent, fetchCountries, fetchVenueFinancials, unloadVenueFinancials } from "../../../../../redux/actions";
import { connect } from "react-redux";

const form = 'vfinancials:event'
let InvoiceAddressForEvent = ({
                                event,
                                unloadVenueFinancials,
                                editVenueFinancialsForEvent,
                                fetchVenueFinancials,
                                fetchCountries,
                                countries,
                                venueFinancials,
                                token,
}) => {
  let [showModal, setShowModal] = useState(false)

  useEffect(() => {
    if(event && event.venue){
      fetchVenueFinancials(token, event.venue.slug);
    }
    fetchCountries(token);
    return () => {
      unloadVenueFinancials();
    };
  }, []);

  const onSubmit = formValues => {
    formValues._method = "PATCH";
    if(formValues.address) {
      const isEmpty = Object.values(formValues.address).every(x => x === null || x === '');
      if(isEmpty) {
        delete formValues.address;
      }
    }
    return editVenueFinancialsForEvent(token, event.venue.slug, event.id, formValues).then((response) => {
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    });
  };

  const onClose = () => {
    setShowModal(false)
  };

  if(!event.venue) {
    return <></>
  }
  return (
    <div>
      <div className="w-full bg-off-white px-3 py-6 my-5 block">
        <p className={"mb-0"}>
          <strong>Invoice Recipient</strong>:{" "}
          {venueFinancials?.invoice_recipient? venueFinancials?.invoice_recipient  : (event?.venue?.name || "Missing")}
        </p>
        <p className={"mb-0"}>
          <strong>Address Line 1</strong>:{" "}
          {venueFinancials?.address && venueFinancials.address_id? venueFinancials?.address.address1  : (event?.venue?.address1 || "Missing")}
        </p>
        <p className={"mb-0"}>
          <strong>Address Line 2</strong>:{" "}
          {venueFinancials?.address && venueFinancials.address_id? venueFinancials?.address.address2  : (event?.venue?.address2 || "Missing")}
        </p>
        <p className={"mb-0"}>
          <strong>Address Line 3</strong>:{" "}
          {venueFinancials?.address && venueFinancials.address_id? venueFinancials?.address.address3  : (event?.venue?.address3 || "Missing")}
        </p>
        <p className={"mb-0"}>
          <strong>Town/City</strong>:{" "}
          {venueFinancials?.address && venueFinancials.address_id? venueFinancials?.address.city  : (event?.venue?.city || "Missing")}
        </p>
        <p className={"mb-0"}>
          <strong>Country</strong>:{" "}
          {venueFinancials?.address && venueFinancials.address_id? venueFinancials?.address.country_name  : (event?.venue?.country?.name  || "Missing")}
        </p>
        <p className={"mb-0"}>
          <strong>PostCode</strong>:{" "}
          {venueFinancials?.address && venueFinancials.address_id? venueFinancials?.address.postcode  : (event?.venue?.postcode  || "Missing")}
        </p>
      </div>
      <ButtonPrimary onClick={() => setShowModal(true)}>{venueFinancials?.address ? 'Edit ' : 'Add '} Billing Address</ButtonPrimary>
      {showModal ? <InvoiceBillingAddressModal event={event} countries={countries} form={form} onSubmit={onSubmit} onClose={onClose}/> : null}
    </div>
  )



}



const mapStateToProps = state => {
  return {
    ...state,
    ...state.venueFinancials,
    ...state.countries,
    token: token(state),
  };
};

const mapDispatchToProps = {
  fetchVenueFinancials,
  fetchCountries,
  editVenueFinancialsForEvent,
  unloadVenueFinancials,
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceAddressForEvent);

